import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Formik, Form as FormikForm } from 'formik';
import * as Yup from 'yup';
import { createOrganizer } from '../../api/Admin';
import OrganizerInformationSection from './createOrganizerForm/OrganizerInformationSection';
import { useState } from 'react';
import Spinner from 'react-bootstrap/esm/Spinner';

function AddOrganizerModal(props) {
  const {
    organizers,
    setToastType,
    setToastTitle,
    setToastBody,
    setShowToast,
    ...rest
  } = props;
  const [updating, setUpdating] = useState(false);

  const organizerSchema = Yup.object().shape({
    name: Yup.string().required('Du måste ange ett klubbnamn'),
    district: Yup.string()
      .required('Du måste välja ett distrikt')
      .oneOf(
        [
          'Gotlands BF',
          'Göteborgs BF',
          'Mellan Norrlands BF',
          'Nedre Norra BF',
          'Smålands BF',
          'Stockholms BF',
          'Söder-/ Västmanlands BF',
          'Södra BF',
          'Upplands BF',
          'Västra BF',
          'Östergötland BF',
          'Övre Norra BF',
        ],
        'Du måste välja ett distrikt'
      ),
    organizationNumber: Yup.string()
      .matches(/^[0-9]+$/, 'Endast siffror tillåtet')
      .min(10, 'För kort organisationsnummer')
      .max(10, 'För långt organisationsnummer')
      .required('Du måste ange ett organisationsnummer'),
    swishNumber: Yup.string()
      .matches(/^[0-9]+$/, 'Endast siffror tillåtet')
      .min(10, 'För kort Swish-nummer')
      .max(10, 'För långt Swish-nummer')
      .test(
        'check-company-number',
        'Swish-numret måste vara ett företagsnummer',
        function (value) {
          if (
            value === undefined ||
            value.toString().substring(0, 3) === '123'
          ) {
            return true;
          }
          return false;
        }
      ),
    email: Yup.string()
      .email('Fel format på angiven e-post')
      .test(
        'check-availability',
        'Angiven e-post är redan registrerad',
        function (value) {
          for (let i = 0; i < organizers?.length; i++) {
            if (value === organizers[i]?.email) {
              return false;
            }
          }
          return true;
        }
      )
      .required('Du måste ange en e-postadress'),
    password: Yup.string()
      .required('Du måste ange ett lösenord')
      .min(8, 'Lösenord måste innehålla minst 8 tecken')
      .matches(/[0-9]/, 'Lösenordet måste innehålla minst en siffra')
      .matches(/[a-z]/, 'Lösenordet måste innehålla minst en liten bokstav')
      .matches(/[A-Z]/, 'Lösenordet måste innehålla minst en stor bokstav')
      .matches(
        /[""!@$%^&*(){}\[\]:;<>,.?/+_=|'~\\-]/,
        'Lösenordet måste innehålla minst ett specialtecken'
      ),
  });

  return (
    <Modal
      {...rest}
      centered
      aria-labelledby='contained-modal-title-vcenter'
      className='p-3'
    >
      <Modal.Header closeButton>
        <Modal.Title>Ny arrangör</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Skapa ett nytt arrangörskonto</p>

        <Formik
          initialValues={{
            name: '',
            district: '',
            organizationNumber: '',
            swishNumber: '',
            email: '',
            password: '',
          }}
          onSubmit={async (values) => {
            setUpdating(true);
            const result = await createOrganizer(values);
            if (result) {
              switch (result.statusCode) {
                case 200:
                  setToastType('success');
                  setToastTitle('Arrangör skapad');
                  setToastBody('Arrangören har blivit skapad');
                  break;
                default:
                  setToastType('danger');
                  setToastTitle('Arrangör ej skapad');
                  setToastBody('Arrangören kunde inte skapas');
                  break;
              }
              props.onHide();
              setShowToast(true);
              setUpdating(false);
            }
          }}
          validationSchema={organizerSchema}
          enableReinitialize={true}
          validateOnChange={false}
          validateOnBlur={false}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            errors,
          }) => (
            <FormikForm
              id='form-add-organizer'
              noValidate
              onSubmit={handleSubmit}
            >
              <OrganizerInformationSection
                values={values}
                handleChange={handleChange}
                handleBlur={handleBlur}
                errors={errors}
                touched={touched}
              />
            </FormikForm>
          )}
        </Formik>
      </Modal.Body>
      <Modal.Footer className='d-flex justify-content-between'>
        <Button onClick={() => props.onHide()} variant='outline-secondary'>
          Avbryt
        </Button>
        <Button type='submit' form='form-add-organizer'>
          {updating ? (
            <>
              <Spinner
                as='span'
                animation='border'
                size='sm'
                role='status'
                aria-hidden='true'
                className='me-2'
              />
              <span className='visually-hidden'>Loading...</span>
              Skapa konto
            </>
          ) : (
            'Skapa konto'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AddOrganizerModal;
